import { SearchApiProcedure } from '@/app/(main)/(pages)/_types/search-api-response.type';

export function toProcedureFallback(procedure: { id: string; name: string; slug: string }): SearchApiProcedure {
  return {
    id: procedure.id,
    name: procedure.name,
    code: '',
    tussCode: '',
    slug: procedure.slug,
    type: '',
    availableForTelehealth: false,
  };
}
